export const constants = {
  urlLocal: process.env.REACT_APP_API_URL,
}

// ⏰ Horas antes del inicio del evento que abren las inscripciones
export const HOURS_BEFORE_OPEN = 51
